import {
    createAction,
} from 'redux-actions'

export const update = createAction('REPORTS/STORE/UPDATE')
export const clear = createAction('REPORTS/STORE/CLEAR')
export const stop = createAction('REPORTS/STORE/STOP', (ids) => ({ids}))
export const review = createAction('REPORTS/STORE/REVIEW', id => ({id}))
export const purge = createAction('REPORTS/STORE/PURGE')